<template>
  <div>
    <b-modal size="xl" id="home-videos" hide-footer hide-header @shown="play(current.url)">
      <div id="close">
        <i class="fas fa-times" @click="close"></i>
      </div>
      <div v-if="section">
        <h2 class="text-center mb-3 h1"><u>{{ current.title }}</u></h2>
        <b-row>
          <b-col md="8" style="padding-top: 33px">
            <b-embed
              type="iframe"
              aspect="16by9"
              :src="url"
              allowfullscreen
            ></b-embed>
          </b-col>
          <b-col md="4">
            <h3 class="text-center mt-0"><u>CHAPTERS</u></h3>
            <b-list-group flush id="chapters">
              <b-list-group-item button v-for="(chapter, index) in chapters" :key="index" class="h5 mb-0" @click="play(chapter.url)" :active="url == chapter.url">{{ chapter.title }}</b-list-group-item>
            </b-list-group>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    section: null
  },
  data() {
    return {
      sections: [
        {
          section: 'features',
          title: 'How to use ClarityNOW to run your business.',
          url: 'https://www.youtube.com/embed/Kuwpiv0R5og?si=cL7JFqOvxbIDHy8O',
          chapters: [
            {
              title: 'Introduction',
              url: 'https://www.youtube.com/embed/Kuwpiv0R5og?si=cL7JFqOvxbIDHy8O'
            },
            {
              title: 'Goal/Gap',
              url: 'https://www.youtube.com/embed/Kuwpiv0R5og?si=cL7JFqOvxbIDHy8O&start=31'
            },
            {
              title: 'Projected Net Profit',
              url: 'https://www.youtube.com/embed/Kuwpiv0R5og?si=cL7JFqOvxbIDHy8O&start=285'
            },
            {
              title: 'CEO Summary',
              url: 'https://www.youtube.com/embed/Kuwpiv0R5og?si=cL7JFqOvxbIDHy8O&start=445'
            },
            {
              title: 'Sales Pipeline',
              url: 'https://www.youtube.com/embed/Kuwpiv0R5og?si=cL7JFqOvxbIDHy8O&start=585'
            },
            {
              title: 'Profit & Loss',
              url: 'https://www.youtube.com/embed/Kuwpiv0R5og?si=cL7JFqOvxbIDHy8O&start=698'
            },
            {
              title: 'Business Plan Report',
              url: 'https://www.youtube.com/embed/Kuwpiv0R5og?si=cL7JFqOvxbIDHy8O&start=897'
            },
            {
              title: 'Lead Source Report',
              url: 'https://www.youtube.com/embed/Kuwpiv0R5og?si=cL7JFqOvxbIDHy8O&start=1048'
            },
          ],
        },
        {
          section: 'agents',
          title: 'How to do an agent 1 on 1 using ClarityNOW.',
          url: 'https://www.youtube.com/embed/0l9efWEVV6w?si=b89np6c6wQWzZhHo',
          chapters: [
            {
              title: 'Observatory',
              url: 'https://www.youtube.com/embed/0l9efWEVV6w?si=b89np6c6wQWzZhHo&start=35' 
            },
            {
              title: 'Goal/Gap',
              url: 'https://www.youtube.com/embed/0l9efWEVV6w?si=b89np6c6wQWzZhHo&start=172' 
            },
            {
              title: 'Sales Pipeline',
              url: 'https://www.youtube.com/embed/0l9efWEVV6w?si=b89np6c6wQWzZhHo&start=425' 
            },
            {
              title: 'Agent Production Reports',
              url: 'https://www.youtube.com/embed/0l9efWEVV6w?si=b89np6c6wQWzZhHo&start=550' 
            },
            {
              title: 'Lead Gen/Conversions',
              url: 'https://www.youtube.com/embed/0l9efWEVV6w?si=b89np6c6wQWzZhHo&start=686' 
            },
          ],
        },
        {
          section: 'meetings',
          title: 'How to use ClarityNOW for running your team meetings.',
          url: 'https://www.youtube.com/embed/HvLAyKHD2nA?si=HnsgK6On3rEhJowq',
          chapters: [
            {
              title: 'Goal/Gap',
              url: 'https://www.youtube.com/embed/HvLAyKHD2nA?si=HnsgK6On3rEhJowq&start=23'
            },
            {
              title: 'Pipeline Reports',
              url: 'https://www.youtube.com/embed/HvLAyKHD2nA?si=HnsgK6On3rEhJowq&start=276'
            },
            {
              title: 'Lead Gen/Conversions',
              url: 'https://www.youtube.com/embed/HvLAyKHD2nA?si=HnsgK6On3rEhJowq&start=402'
            },
          ],
        },
        {
          section: 'finances',
          title: 'How to use ClarityNOW to manage your finances.',
          url: 'https://www.youtube.com/embed/dNabZDak_Zo?si=jFVYfdrSRrlNwcaK',
          chapters: [
            {
              title: 'Expenses',
              url: 'https://www.youtube.com/embed/dNabZDak_Zo?si=jFVYfdrSRrlNwcaK&start=29'
            },
            {
              title: 'Profit & Loss',
              url: 'https://www.youtube.com/embed/dNabZDak_Zo?si=jFVYfdrSRrlNwcaK&start=227'
            },
            {
              title: 'Projected Net Profits',
              url: 'https://www.youtube.com/embed/dNabZDak_Zo?si=jFVYfdrSRrlNwcaK&start=426'
            },
          ],
        },
        {
          section: 'planning',
          title: 'How to do business planning in ClarityNOW.',
          url: 'https://www.youtube.com/embed/lN0M7W5ECv0?si=EkqQ6DH3ideU27VK',
          chapters: [
            {
              title: 'Economic Model',
              url: 'https://www.youtube.com/embed/lN0M7W5ECv0?si=EkqQ6DH3ideU27VK&start=29'
            },
            {
              title: 'Budget Model',
              url: 'https://www.youtube.com/embed/lN0M7W5ECv0?si=EkqQ6DH3ideU27VK&start=614'
            },
            {
              title: 'Lead Gen Model',
              url: 'https://www.youtube.com/embed/lN0M7W5ECv0?si=EkqQ6DH3ideU27VK&start=855'
            },
          ],
        }
      ],
      url: null
    }
  },
  computed: {
    current() {
      return this.sections.filter((section) => {
        return section.section == this.section;
      })[0];
    },
    chapters() {
      return this.sections.filter((section) => {
        return section.section == this.section;
      })[0].chapters;
    },
  },
  methods: {
    play(url) {
      this.url = url;
    },
    close() {
      this.$bvModal.hide('home-videos');
    },
  }
}
</script>
<style lang="scss">
#chapters.list-group {
  .list-group-item.active {
    background-color: #D45E5E;
    border: 0;
  }
}
#close {
  position: absolute;
  right: 13px;
  top: 6px;
  cursor: pointer;
}
</style>